import React, { Component } from "react"

const DrawerContext = React.createContext({})
export const DrawerProvider = DrawerContext.Provider
export const DrawerConsumer = DrawerContext.Consumer
export default class SharedDrawerContext extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      openSecondary: false,
      openTertiary: false,
      preventTertiaryFromOpeningAutomatically: false,
      drawerUsePath: ""
    }
    this.toggleDrawer = this.toggleDrawer.bind(this)
    this.closeSecondary = this.closeSecondary.bind(this)
    this.toggleSecondary = this.toggleSecondary.bind(this)
    this.openSecondaryDrawer = this.openSecondaryDrawer.bind(this)
    this.openTertiaryDrawer = this.openTertiaryDrawer.bind(this)
    this.openDrawer = this.openDrawer.bind(this)
    this.closeAllDrawers = this.closeAllDrawers.bind(this)
    this.closeTertiaryDrawer = this.closeTertiaryDrawer.bind(this)
    this.openDrawerAndPreventTertiary = this.openDrawerAndPreventTertiary.bind(
      this
    )
  }

  // you'll know when you need use this
  openDrawerAndPreventTertiary() {
    this.setState({
      open: true,
      drawerUsePath: "primary-",
      preventTertiaryFromOpeningAutomatically: true
    })
  }

  openTertiaryDrawer(renderComponent) {
    this.setState({
      openTertiary: true,
      drawerUsePath: `${this.state.drawerUsePath}tertiary-`,
      renderTertiaryComponent: renderComponent
    })
  }

  openDrawer() {
    this.setState({
      open: true,
      drawerUsePath: "primary-"
    })
  }

  closeAllDrawers() {
    this.setState({
      open: false,
      openSecondary: false,
      openTertiary: false,
      drawerUsePath: "",
      preventTertiaryFromOpeningAutomatically: false
    })
  }

  toggleDrawer() {
    this.setState({
      open: !this.state.open
    })
  }

  openSecondaryDrawer(renderComponent) {
    this.setState({
      openSecondary: true,
      drawerUsePath: `${this.state.drawerUsePath}secondary-`,
      renderSecondaryComponent: renderComponent
    })
  }

  closeTertiaryDrawer() {
    this.setState({
      openTertiary: false
    })
  }

  closeSecondary() {
    this.setState({
      openSecondary: false
    })
  }

  toggleSecondary() {
    this.state.openSecondary
      ? this.setState({
          openSecondary: !this.state.openSecondary,
          open: false
        })
      : this.setState({
          openSecondary: !this.state.openSecondary
        })
  }

  render() {
    return (
      <DrawerProvider
        value={{
          drawerOpen: this.state.open,
          toggleDrawer: this.toggleDrawer,
          openDrawer: this.openDrawer,
          closeAllDrawers: this.closeAllDrawers,
          secondaryOpen: this.state.openSecondary,
          openSecondaryDrawer: this.openSecondaryDrawer,
          openTertiaryDrawer: this.openTertiaryDrawer,
          closeSecondary: this.closeSecondary,
          toggleSecondary: this.toggleSecondary,
          renderSecondaryComponent: this.state.renderSecondaryComponent,
          renderTertiaryComponent: this.state.renderTertiaryComponent,
          openTertiary: this.state.openTertiary,
          closeTertiaryDrawer: this.closeTertiaryDrawer,
          drawerUsePath: this.state.drawerUsePath,
          preventTertiaryFromOpeningAutomatically: this.state
            .preventTertiaryFromOpeningAutomatically,
          openDrawerAndPreventTertiary: this.openDrawerAndPreventTertiary
        }}
      >
        {this.props.children}
      </DrawerProvider>
    )
  }
}
